/* eslint-disable no-underscore-dangle */
// Method to set a cookie
export const setCookie = (name, value, domain, expiryType, expireVal) => {
  let expires
  const date = new Date()
  switch (expiryType) {
    case 'hr':
      date.setTime(date.getTime() + (expireVal * 60 * 60 * 1000))
      expires = `; expires=${date}`
      break
    case 'min':
      date.setTime(date.getTime() + (expireVal * 60 * 1000))
      expires = `; expires=${date}`
      break
    case 'days':
      date.setDate(date.getDate() + expireVal)
      expires = `; expires=${date}`
      break
    default:
      expires = ''
  }
  document.cookie = `${encodeURI(name)}=${encodeURI(value)}${expires}; path=/;domain=${domain}`
}

export const getCookieByName = (name) => {
  const regex = new RegExp(`${name}=([^;]+)`)
  const value = regex.exec(document.cookie)
  if (value && value.length) return unescape(value[1])
  return false
}

export const setPerimeterXWindow = (login) => {
  window._pxreCaptchaTheme = 'light'
  window._pxAppId = login.appId
  window._pxJsClientSrc = login.jsClientSrc
  window._pxFirstPartyEnabled = login.firstPartyEnabled
  window._pxVid = login.vid
  window._pxUuid = login.uuid
  window._pxHostUrl = login.hostUrl
}

export const unsetPerimeterXWindow = () => {
  window._pxAppId = null
  window._pxJsClientSrc = null
  window._pxFirstPartyEnabled = null
  window._pxVid = null
  window._pxUuid = null
  window._pxHostUrl = null
  window._pxOnCaptchaSuccess = null
}
